import {LoadingDots} from '#/atoms/dots-loading-indicator';
import {ReactComponent as IconClose} from '#/components/icons/ico-close.svg';
import {useLands} from '#/hooks/query/use-lands';
import {motion} from 'framer-motion';
import {FunctionComponent, Suspense, lazy} from 'react';
import {useTranslation} from 'react-i18next';
import {Land} from 'shareland-common';

const TradingViewLazy = lazy(() => import('./trading-view'));

export const TradingViewModal: FunctionComponent<{land?: Land; onCloseModal: () => void}> = ({land, onCloseModal}) => {
  const {t} = useTranslation('translation');

  const {data: lands} = useLands();

  return (
    <motion.div
      initial={{opacity: 0}}
      animate={{opacity: 1}}
      exit={{opacity: 0}}
      transition={{ease: 'easeInOut', duration: 0.2}}
      className='fixed grid top-0 left-0 w-full h-full place-items-center z-50 bg-black/[.5] p-6'
      onClick={onCloseModal}
    >
      <motion.div
        initial={{opacity: 0, scale: 0.75}}
        animate={{opacity: 1, scale: 1}}
        exit={{opacity: 0, scale: 0}}
        transition={{ease: 'easeInOut', duration: 0.2}}
        className='flex flex-col bg-white rounded border w-full h-full'
      >
        <div className='bg-black pl-6 py-4 flex justify-between rounded-t'>
          <span className='text-white font-bold'>{t('pages.advancedTradingView.title')}</span>
          <button className='ml-6 mr-4' onClick={e => onCloseModal}>
            <IconClose className='hover:fill-blue-600' />
          </button>
        </div>
        <div className='w-full grow'>
          {lands && (
            <Suspense fallback={<LoadingDots />}>
              <TradingViewLazy lands={lands} land={land} />
            </Suspense>
          )}
        </div>
      </motion.div>
    </motion.div>
  );
};
